module.exports = __webpack_public_path__ + "static/media/access.3b4a4708.png";